import { render, staticRenderFns } from "./AutoSummaryPage.vue?vue&type=template&id=53b6bc8e&scoped=true&"
import script from "./AutoSummaryPage.vue?vue&type=script&lang=js&"
export * from "./AutoSummaryPage.vue?vue&type=script&lang=js&"
import style0 from "./AutoSummaryPage.vue?vue&type=style&index=0&id=53b6bc8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b6bc8e",
  null
  
)

export default component.exports